import { formatReferenceViewID } from './formatReferenceViewID.ts';
import { ReferenceViewID, ReferenceViewIDParsed } from './types.ts';

export const propertyIdToReferenceViewId = (propertyId: string): ReferenceViewID => {
  const isSubject = propertyId === 'subject';
  const parsedReferenceViewId: ReferenceViewIDParsed = isSubject
    ? { type: 'subject' }
    : {
        type: 'comparable',
        compID: propertyId,
      };

  return formatReferenceViewID(parsedReferenceViewId);
};
